import updateNewSoftwareVersionsCount from '../actions/updateNewSoftwareVersionsCount';

export default function streamboxesReducer(state = { newSoftwareVersionCount: 0 }, action) {
    switch (action.type) {
        case updateNewSoftwareVersionsCount.type:
            return { newSoftwareVersionCount: action.payload };
        default:
            return state;
    }
}
